module.exports = __webpack_public_path__ + "img/1722991296575-keripik nesyandra.jpg.d9177e6d.webp";